import { render, staticRenderFns } from "./_base-dot.vue?vue&type=template&id=fad9a8dc&scoped=true&"
import script from "./_base-dot.vue?vue&type=script&lang=js&"
export * from "./_base-dot.vue?vue&type=script&lang=js&"
import style0 from "./_base-dot.vue?vue&type=style&index=0&id=fad9a8dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad9a8dc",
  null
  
)

export default component.exports